module.exports = __webpack_public_path__ + "static/media/TESTE_USABILIDADE_GRANEL.cc758097.jpg";